import React from "react";
import E_TermsAndPolicy from "./view/_terms_policies";

export default function TermsAndPolicy(){
    return(<>
    <E_TermsAndPolicy />
    </>)
}